import { useState } from 'react'
import { KeycloakAdminService } from '@nv/auth'
import { NVButton } from '@nv/basic-components'
import { ActionDropdown, ImageModal, useNVModal } from '@nv/components'
import GreenSmCheckIcon from '@nv/images/design/green-sm-check-icon'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from '../AdminEligibleDetails.module.scss'

export const RegistartionDetails = ({ user, setEditUserModalView, openEditUserModal, openConfirmUnlockAdminModal, getUser }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const electorActionOptions = [{ value: 'View', label: t('admin.dropdown.view') }]
  if (KeycloakAdminService.isSuperAdmin() || KeycloakAdminService.isVBMAdmin()) {
    electorActionOptions.push({ value: 'Edit', label: t('admin.dropdown.edit') })
  }
  if (user.votingChannel === 'online') {
    electorActionOptions.push({ value: 'Resend access email', label: t('admin.dropdown.resendAccessEmail') })
    electorActionOptions.push({ value: 'Reset password', label: t('admin.users.actions.resetPassword') })

    if (user.onlineVoter?.disabled && user.onlineVoter?.votingChannel === 'online') {
      electorActionOptions.push({ value: 'Unlock', label: t('buttons.unlock') })
    }
  }

  const [selectedImage, setSelectedImage] = useState(null)
  const { NVModal: LargeImageModal, openModal: openLargeImageModal } = useNVModal()
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl)
    openLargeImageModal()
  }

  const onClickViewPDF = async (i) => {
    await getUser()
    // @ts-ignore
    const identification = user.onlineVoter.voterInfo.identification[i]
    window.open(identification.fileUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <>
      <LargeImageModal>
        <ImageModal image={selectedImage && selectedImage} />
      </LargeImageModal>
      <span className={styles['registration-header']}>{t('registration.registration')}</span>

      <div className={styles['details__section']}>
        <div className={styles['details__names']}>
          <div className={styles['details__name']}>
            <div className={styles['details__label']}>{t('form.labels.username')}</div>
            <div className={styles['details__text']}>{user.onlineVoter.username}</div>
          </div>
          <div className={styles['details__name']}>
            <div className={styles['details__label']}>{t('form.labels.email')}</div>
            <div className={styles['details__text']}>{user.onlineVoter.email}</div>
          </div>
          <div className={styles['details__name']}>
            <div className={styles['details__label']}>{t('form.labels.phone')}</div>
            <div className={styles['details__text']}>{user.onlineVoter.phone}</div>
          </div>
        </div>
        <div className={styles['details__name']}>
          <ActionDropdown
            values={electorActionOptions}
            onCallback={(choice) => {
              const voterId = user.onlineVoter.voterInfo._id
              switch (choice) {
                case 'View':
                  if (voterId) navigate(`/admin/registrant-details/${voterId}`)
                  else alert('User is not viewable.')
                  break
                case 'Unlock':
                  openConfirmUnlockAdminModal()
                  break
                default:
                  setEditUserModalView(choice)
                  openEditUserModal()
              }
            }}
          />
        </div>
      </div>
      <div>
        <div className={styles['details__name']}>
          {!user.onlineVoter?.electionOptIns ? null : (
            <>
              <div className={styles['details__label']}>{t('admin.electorsDetails.registeredVotingDistricts')}</div>
              {user.onlineVoter?.electionOptIns
                .split(',')
                .sort()
                .map((district, i) => {
                  if (district)
                    return (
                      <div key={i} className={clsx(styles['details__text'], styles['details__icon'])}>
                        <GreenSmCheckIcon />{' '}
                        {district.toLowerCase().includes('none')
                          ? t('registration.schoolboards.none')
                          : district.includes('PSB')
                          ? t('registration.schoolboards.PSB')
                          : district.includes('CSLF')
                          ? t('registration.schoolboards.CSLF')
                          : ''}
                      </div>
                    )
                })}
            </>
          )}
        </div>
        {!user.onlineVoter.ballotOptIns ? null : (
          <div className={styles['details__name']}>
            <div className={styles['details__label']}>{t('Ballot Options')}</div>
            {user.onlineVoter.ballotOptIns.map((ballot, i) => {
              return (
                <div key={i} className={clsx(styles['details__text'], styles['details__icon'])}>
                  <GreenSmCheckIcon />
                  {ballot.toLowerCase().includes('none')
                    ? t('registration.ballots.ballot3')
                    : ballot.includes('councillor')
                    ? t('registration.ballots.ballot2')
                    : ballot.includes('mayor')
                    ? t('registration.ballots.ballot1')
                    : ''}
                </div>
              )
            })}
          </div>
        )}
      </div>

      {user.onlineVoter.voterInfo.identification?.length && (KeycloakAdminService.isVBMAdmin() || KeycloakAdminService.isSuperAdmin()) ? (
        <div className={styles['details__section']}>
          <div className={styles['details__name']}>
            <div className={styles['details__label']}>{t('registration.proofOfIdentity')}</div>
            <div className={styles['details__image-container']}>
              {user.onlineVoter.voterInfo.identification.map((identification, index) =>
                identification.filename.endsWith('.pdf') ? (
                  <NVButton key={index} text='View PDF' onClick={() => onClickViewPDF(index)} />
                ) : (
                  <NVButton
                    key={index}
                    variant='iconOnly'
                    onClick={() => handleImageClick(identification.fileUrl)}
                    icon={<img src={identification.fileUrl} alt={'Identification ' + index} />}
                  />
                ),
              )}
            </div>
          </div>
        </div>
      ) : null}

      {!user.onlineVoter.voterInfo.onElectorsList && (
        <div className={styles['details__section']}>
          <div className={styles['details__names']}>
            <div className={styles['details__name']}>
              <div className={styles['details__label']}>{t('registration.signature.label')}</div>
              <div className={styles['details__text']}>{user.onlineVoter.signature}</div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
